import { useForm } from "react-hook-form";
import { useRecoilState } from "recoil";
import { writingDetailInfoAtom } from "./Atom/writingDetailInfoAtom";
import { formFlowAtom } from "./Atom/formFlowAtom";
import axios from "axios";

interface WriteAnswersFormType {
  answers: string[];
}

const WriteAnswersForm = () => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<WriteAnswersFormType>();

  const [detailInfo, setDetailInfo] = useRecoilState(writingDetailInfoAtom);
  const [flow, setFlow] = useRecoilState(formFlowAtom);

  const API_ENDPOINT = "https://your-api-endpoint.com";

  const dummyQuestions = [
    "등장인물들은 어떤 배경을 가진 학생들인가요? (예: 성격, 관계, 학교에서의 위치 등)",
    "비밀은 어떤 종류이며, 그 비밀이 드러나면 등장인물들에게 어떤 영향을 미치나요?",
    "이야기가 펼쳐지는 주요 배경은 어디인가요? (예: 교실, 운동장, 동아리실 등)",
    "비밀을 둘러싼 주요 사건이나 갈등은 어떻게 발생하고, 해결 과정에서 어떤 희극적 요소가 들어가나요?",
    "이 희극을 통해 독자(또는 관객)에게 전달하고자 하는 메시지는 무엇인가요?",
  ];

  const onValid = async (data: WriteAnswersFormType) => {
    try {
      // Send the answers to the API or handle them as needed
      //   const response = await axios.post(`${API_ENDPOINT}/submit`, data);
      //   console.log("Response:", response.data);

      // Update recoil state or move to the next step
      setDetailInfo((prev) => ({
        ...prev,
        answers: data.answers,
      }));

      setFlow(6);
    } catch (error) {
      console.error("Error submitting answers:", error);
    }
  };

  const onInvalid = (errors: any) => {
    console.log("Errors:", errors);
  };

  return (
    <div className="p-6 max-w-lg mx-auto bg-white dark:bg-slate-700 rounded-lg shadow-md">
      <div className="text-xl font-bold mb-4">질문에 답변해주세요!</div>
      <form onSubmit={handleSubmit(onValid, onInvalid)}>
        {dummyQuestions.map((question, index) => (
          <div key={index} className="mb-4">
            <label
              htmlFor={`answer${index}`}
              className="block text-gray-500 dark:text-slate-100 font-medium mb-2"
            >
              {question}
            </label>
            <input
              id={`answer${index}`}
              {...register(`answers.${index}` as const, {
                required: "이 질문에 대한 답변을 작성해주세요!",
              })}
              className="block w-full mt-2 p-2 border border-gray-300 dark:bg-slate-600 rounded-lg"
              placeholder="답변을 작성해주세요"
            />
            {errors.answers?.[index] && (
              <p className="text-red-500 mt-2">
                {errors.answers[index]?.message}
              </p>
            )}
          </div>
        ))}

        <button
          type="submit"
          className="px-4 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600"
        >
          글창작하기
        </button>
      </form>
    </div>
  );
};

export default WriteAnswersForm;
